<template>
  <slot />
  <CheckoutFooter/>
</template>

<script setup>
  
</script>